document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("myModal");
  const openModalBtn = document.querySelector(".size-chart-trigger");
  const closeModalBtn = modal.querySelector(".product-modal__close");

  if (!openModalBtn) {
    return;
  }

  document.body.appendChild(modal);

  function openModal() {
    modal.setAttribute("open", "");
    document.documentElement.style.overflowY = "hidden";
  }

  function closeModal() {
    modal.removeAttribute("open");
    document.documentElement.style.overflowY = "auto";
  }

  openModalBtn.addEventListener("click", openModal);

  closeModalBtn.addEventListener("click", closeModal);

  window.addEventListener("click", function (event) {
    if (event.target === modal) {
      closeModal();
    }
  });
});
